export default __webpack_public_path__ + "static/media/LogoMof_Cor.4dc85b85.svg";